import React from "react";

export function LevelLanguage({ level, setLevel, language, setLanguage }) {
  const levels = [
    { v: "school", label: "School (4–10)" },
    { v: "college", label: "College / 11–UG" },
    { v: "youth", label: "Youth & Careers" },
  ];
  const langs = [
    { v: "english", label: "English" },
    { v: "hindi", label: "Hindi" },
    { v: "spanish", label: "Spanish" },
  ];
  return (
    <div className="flex flex-wrap gap-3" data-testid="level-language-controls">
      <div className="flex flex-wrap gap-1.5" data-testid="level-group">
        {levels.map((l) => (
          <button
            key={l.v}
            onClick={() => setLevel(l.v)}
            data-testid={`level-${l.v}`}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition ${
              level === l.v
                ? "bg-[#3A5A40] text-white"
                : "bg-white border border-[#DCD7CE] text-[#1A1A1A] hover:border-[#3A5A40]"
            }`}
          >
            {l.label}
          </button>
        ))}
      </div>
      <div className="flex gap-1.5" data-testid="language-group">
        {langs.map((l) => (
          <button
            key={l.v}
            onClick={() => setLanguage(l.v)}
            data-testid={`lang-${l.v}`}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition ${
              language === l.v
                ? "bg-[#E07A5F] text-white"
                : "bg-white border border-[#DCD7CE] text-[#1A1A1A] hover:border-[#E07A5F]"
            }`}
          >
            {l.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export function Loader({ label = "Thinking…" }) {
  return (
    <div className="flex items-center gap-2 text-[#4A4A4A] text-sm" data-testid="loader">
      <span className="inline-block w-2 h-2 rounded-full bg-[#E07A5F] animate-pulse" />
      <span className="inline-block w-2 h-2 rounded-full bg-[#E07A5F] animate-pulse [animation-delay:120ms]" />
      <span className="inline-block w-2 h-2 rounded-full bg-[#E07A5F] animate-pulse [animation-delay:240ms]" />
      <span className="ml-1">{label}</span>
    </div>
  );
}

export function SectionTitle({ kicker, title, subtitle }) {
  return (
    <div className="mb-8 md:mb-10">
      {kicker && (
        <div className="text-[11px] tracking-[0.24em] uppercase font-semibold text-[#3A5A40] mb-3">{kicker}</div>
      )}
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] tracking-tight">{title}</h2>
      {subtitle && <p className="mt-3 text-[#4A4A4A] max-w-2xl">{subtitle}</p>}
    </div>
  );
}
